import { FieldRepository } from "@/core/fields";
import { currentUser } from "@/core/users/session";
import { tableFieldsLevante } from "./lib/zones/levante";
// Individual field definitions (for registration and lookups)
export const FIELDS = new FieldRepository([
    // Basic fields
    {
        key: "region_de_ventas",
        label: "Región de ventas",
        type: "string",
        align: "left",
    },
    {
        key: "delegacion_zona_de_ventas",
        label: "Delegación + Sala + Ruta",
        type: "string",
        align: "left",
    },
    {
        key: "distribuidor",
        label: "Distribuidor",
        type: "string",
        align: "left",
    },
    // Volumen fields (individual)
    {
        key: "volumen.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.objetivo_porcentaje",
        label: "Objetivo %",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.cajas_faltantes",
        label: "Cajas Faltantes",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Volumen Acumulado fields (individual)
    {
        key: "volumen_acumulado.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.objetivo_porcentaje",
        label: "Objetivo %",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen_acumulado.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.cajas_faltantes",
        label: "Cajas Faltantes",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_acumulado.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Clientes fields (individual)
    {
        key: "clientes.periodo_actual",
        label: "Periodo Actual",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.periodo_anterior",
        label: "Periodo Anterior",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.objetivo",
        label: "Objetivo",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.clientes_faltantes",
        label: "Faltantes",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Ref Promedio fields (individual)
    {
        key: "ref_promedio.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "ref_promedio.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "ref_promedio.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // GDA fields (individual)
    {
        key: "gda.obj_ho_f1",
        label: "Obj HO F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f1",
        label: "Rtdo HO F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_ho_f2",
        label: "Obj HO F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f2",
        label: "Rtdo HO F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_ho_f3",
        label: "Obj HO F3",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_ho_f3",
        label: "Rtdo HO F3",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f1",
        label: "Obj AL F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f1",
        label: "Rtdo AL F1",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f2",
        label: "Obj AL F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f2",
        label: "Rtdo AL F2",
        type: "float",
        align: "right",
    },
    {
        key: "gda.obj_al_f3",
        label: "Obj AL F3",
        type: "float",
        align: "right",
    },
    {
        key: "gda.rtdo_al_f3",
        label: "Rtdo AL F3",
        type: "float",
        align: "right",
    },
    // Computed total fields
    {
        key: "total_volumen",
        label: "Total Volumen",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 1 },
    },
    {
        key: "total_volumen_acumulado",
        label: "Total Volumen Acumulado",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 1 },
    },
    // Norte KPI red_revisada fields (values stored as whole-number percentages, e.g. 44 = 44%)
    {
        key: "clientes_productivos.red_revisada",
        label: "Red Revisada",
        type: "string",
        align: "right",
        formatter: (value) => value != null ? `${value}%` : "-",
    },
    {
        key: "clientes_productivos.objetivo_cf",
        label: "Objetivo Clientes",
        type: "integer",
        align: "right",
    },
    {
        key: "cf_vidrio_retornable.objetivo_cf",
        label: "Objetivo CF",
        type: "integer",
        align: "right",
    },
    {
        key: "cf_vidrio_retornable.red_revisada",
        label: "Red Revisada",
        type: "string",
        align: "right",
        formatter: (value) => value != null ? `${value}%` : "-",
    },
    {
        key: "rutas_cfl_clientes_fuze_mantener.red_revisada",
        label: "Red Revisada",
        type: "string",
        align: "right",
        formatter: (value) => value != null ? `${value}%` : "-",
    },
    // Cajas fields (Norte - individual)
    {
        key: "cajas.periodo_actual",
        label: "Periodo Actual",
        type: "integer",
        align: "right",
    },
    {
        key: "cajas.periodo_anterior",
        label: "Periodo Anterior",
        type: "integer",
        align: "right",
    },
    {
        key: "cajas.objetivo",
        label: "Objetivo",
        type: "integer",
        align: "right",
    },
    {
        key: "cajas.clientes_faltantes",
        label: "Faltantes",
        type: "integer",
        align: "right",
    },
    {
        key: "cajas.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    // Catalunya specific fields
    {
        key: "delegacion",
        label: "Delegación",
        type: "string",
        align: "left",
    },
    {
        key: "zona_de_ventas",
        label: "Ruta",
        type: "string",
        align: "left",
    },
    {
        key: "sala",
        label: "Sala",
        type: "string",
        align: "left",
    },
    // Catalunya KPI 1: Volumen - fields
    {
        key: "volumen_catalunya.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_catalunya.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_catalunya.objetivo_porcentaje",
        label: "% Objetivo",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole" },
    },
    {
        key: "volumen_catalunya.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "volumen_catalunya.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    {
        key: "volumen_catalunya.porcentaje_red",
        label: "% Curva",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole", maximumFractionDigits: 0 },
    },
    {
        key: "volumen_catalunya.red_revisada",
        label: "% Curva Revisada",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole" },
    },
    // Catalunya KPI 2: Clientes - fields
    {
        key: "clientes_catalunya.periodo_actual",
        label: "Periodo Actual",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes_catalunya.periodo_anterior",
        label: "Periodo Anterior",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes_catalunya.objetivo_porcentaje",
        label: "% Objetivo",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole" },
    },
    {
        key: "clientes_catalunya.objetivo_cu",
        label: "Objetivo CU",
        type: "integer",
        align: "right",
    },
    {
        key: "clientes_catalunya.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    {
        key: "clientes_catalunya.porcentaje_red",
        label: "% Curva",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole", maximumFractionDigits: 0 },
    },
    {
        key: "clientes_catalunya.red_revisada",
        label: "% Red Revisada",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole" },
    },
    // Catalunya KPI 3: Cilindros Refrescos VR - fields
    {
        key: "cilindros_refrescos_vr_catalunya.periodo_actual",
        label: "Periodo Actual",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "cilindros_refrescos_vr_catalunya.periodo_anterior",
        label: "Periodo Anterior",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "cilindros_refrescos_vr_catalunya.objetivo_porcentaje",
        label: "% Objetivo",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole" },
    },
    {
        key: "cilindros_refrescos_vr_catalunya.objetivo_cu",
        label: "Objetivo CU",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "cilindros_refrescos_vr_catalunya.porcentaje_conseguido",
        label: "% Conseguido",
        type: "percent",
        align: "right",
    },
    {
        key: "cilindros_refrescos_vr_catalunya.porcentaje_red",
        label: "% Curva",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole", maximumFractionDigits: 0 },
    },
    {
        key: "cilindros_refrescos_vr_catalunya.red_revisada",
        label: "% Curva Revisada",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole" },
    },
    {
        key: "resultados.redencion_total",
        label: "% Redencion Total",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole", maximumFractionDigits: 0 },
    },
    {
        key: "resultados.redencion_revisada",
        label: "% Redencion Revisada",
        type: "percent",
        align: "right",
        formatOptions: { percentInputScale: "whole", maximumFractionDigits: 0 },
    },
    {
        key: "resultados.volumen",
        label: "Volumen",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
    {
        key: "resultados.comision",
        label: "Comision/Caja",
        type: "float",
        align: "right",
        formatOptions: { maximumFractionDigits: 3 },
    },
    {
        key: "resultados.importe_total",
        label: "Importe Total",
        type: "currency",
        align: "right",
        formatOptions: { maximumFractionDigits: 2 },
    },
]);
// Helper function to get field by key
const getField = (key, overrides = {}) => {
    return Object.assign(Object.assign({}, FIELDS.get(key)), overrides);
};
// Grouped table fields structure for CENTRO
export const TABLE_FIELDS_CENTER = [
    // Basic fields (no group)
    getField("delegacion_zona_de_ventas", { width: "220px" }),
    getField("distribuidor", { width: "300px" }),
    // Volumen group
    {
        key: "volumen",
        label: "Volumen",
        type: "group",
        children: [
            getField("volumen.periodo_actual"),
            getField("volumen.periodo_anterior"),
            getField("volumen.objetivo_porcentaje"),
            getField("volumen.objetivo_cu"),
            getField("volumen.cajas_faltantes"),
            getField("volumen.porcentaje_conseguido"),
        ],
    },
    // Volumen Acumulado group
    {
        key: "volumen_acumulado",
        label: "Volumen Acumulado",
        type: "group",
        children: [
            getField("volumen_acumulado.periodo_actual"),
            getField("volumen_acumulado.periodo_anterior"),
            getField("volumen_acumulado.objetivo_porcentaje"),
            getField("volumen_acumulado.objetivo_cu"),
            getField("volumen_acumulado.cajas_faltantes"),
            getField("volumen_acumulado.porcentaje_conseguido"),
        ],
    },
    // Clientes group
    {
        key: "clientes",
        label: "Clientes",
        type: "group",
        children: [
            getField("clientes.periodo_actual"),
            getField("clientes.periodo_anterior"),
            getField("clientes.objetivo"),
            getField("clientes.clientes_faltantes"),
            getField("clientes.porcentaje_conseguido"),
        ],
    },
    // Ref Promedio group
    {
        key: "ref_promedio",
        label: "Ref. Promedio",
        type: "group",
        children: [
            getField("ref_promedio.periodo_actual"),
            getField("ref_promedio.periodo_anterior"),
            getField("ref_promedio.porcentaje_conseguido"),
        ],
    },
    // GDA group
    {
        key: "gda",
        label: "GDA",
        type: "group",
        children: [
            getField("gda.obj_ho_f1"),
            getField("gda.rtdo_ho_f1"),
            getField("gda.obj_ho_f2"),
            getField("gda.rtdo_ho_f2"),
            getField("gda.obj_ho_f3"),
            getField("gda.rtdo_ho_f3"),
            getField("gda.obj_al_f1"),
            getField("gda.rtdo_al_f1"),
            getField("gda.obj_al_f2"),
            getField("gda.rtdo_al_f2"),
            getField("gda.obj_al_f3"),
            getField("gda.rtdo_al_f3"),
        ],
    },
    // % Cumplimiento
    {
        key: "porcentaje_cumplimiento",
        label: "% Cumplimiento",
        type: "group",
        children: [
            getField("porcentaje_cumplimiento.volumen"),
            getField("porcentaje_cumplimiento.volumen_acumulado"),
            getField("porcentaje_cumplimiento.clientes"),
            getField("porcentaje_cumplimiento.ref_promedio"),
            getField("porcentaje_cumplimiento.ho_f1"),
            getField("porcentaje_cumplimiento.ho_f2"),
            getField("porcentaje_cumplimiento.ho_f3"),
            getField("porcentaje_cumplimiento.al_f1"),
            getField("porcentaje_cumplimiento.al_f2"),
            getField("porcentaje_cumplimiento.al_f3"),
        ],
    },
    // Total fields (no group)
    getField("total_volumen"),
    getField("total_volumen_acumulado"),
];
// Grouped table fields structure for NORTE
export const TABLE_FIELDS_NORTH = [
    // Basic fields (no group)
    getField("delegacion", { width: "220px" }),
    getField("sala", { width: "220px" }),
    getField("distribuidor", { width: "300px" }),
    // KPI 1
    {
        key: "clientes_productivos",
        label: "1º KPI: TOTAL CLIENTES CON VENTA NETA > 0",
        type: "group",
        color: "#4472C4",
        children: [
            getField("clientes_productivos.periodo_actual"),
            getField("clientes_productivos.periodo_anterior"),
            getField("clientes_productivos.objetivo_porcentaje", { label: "%Obj crec", type: "percent" }),
            getField("clientes_productivos.objetivo_cf", { label: "Obj Clientes" }),
            getField("clientes_productivos.porcentaje_cumplimiento", { label: "% Crec conseguido" }),
            getField("clientes_productivos.porcentaje_red"),
            getField("clientes_productivos.red_revisada"),
        ],
    },
    // KPI 2
    {
        key: "cf_vidrio_retornable",
        label: "2º KPI: CF REFRESCOS VIDRIO RETORNABLE",
        type: "group",
        color: "#808080",
        children: [
            getField("cf_vidrio_retornable.periodo_actual"),
            getField("cf_vidrio_retornable.periodo_anterior"),
            getField("cf_vidrio_retornable.objetivo_porcentaje", { label: "%Obj crec", type: "percent" }),
            getField("cf_vidrio_retornable.objetivo_cf"),
            getField("cf_vidrio_retornable.porcentaje_cumplimiento", { label: "% Crec conseguido" }),
            getField("cf_vidrio_retornable.porcentaje_red"),
            getField("cf_vidrio_retornable.red_revisada"),
        ],
    },
    // KPI 4
    {
        key: "rutas_cfl_clientes_fuze_mantener",
        label: "2º KPI RUTAS CFL:: CLIENTES FUZE MANTENER",
        type: "group",
        color: "#808080",
        children: [
            getField("rutas_cfl_clientes_fuze_mantener.periodo_actual"),
            getField("rutas_cfl_clientes_fuze_mantener.periodo_anterior"),
            getField("rutas_cfl_clientes_fuze_mantener.porcentaje_cumplimiento"),
            getField("rutas_cfl_clientes_fuze_mantener.porcentaje_red"),
            getField("rutas_cfl_clientes_fuze_mantener.red_revisada"),
        ],
    },
    // KPI 3 (canon variable - mostrar al final)
    {
        key: "canon_variable",
        label: "Canón variable",
        type: "group",
        color: "#70AD47",
        children: [
            getField("canon_variable.red_total", { type: "percent" }),
            getField("canon_variable.periodo_actual"),
            getField("canon_variable.periodo_anterior", { hidden: true }),
            getField("canon_variable.porcentaje_crecimiento", { label: "% crecimiento" }),
            getField("canon_variable.comision", { type: "string" }),
            getField("canon_variable.importe_total", { type: "float", formatOptions: { maximumFractionDigits: 4 } }),
        ],
    },
];
// Grouped table fields structure for CATALUNYA
export const TABLE_FIELDS_CATALUNYA = [
    // Basic fields (no group)
    getField("delegacion", { width: "220px" }),
    getField("distribuidor", { width: "300px" }),
    // KPI 1: Volumen (40%)
    {
        key: "volumen_catalunya",
        label: "1º KPI: VOLUMEN (40%)",
        type: "group",
        children: [
            getField("volumen_catalunya.periodo_actual"),
            getField("volumen_catalunya.periodo_anterior"),
            getField("volumen_catalunya.objetivo_porcentaje"),
            getField("volumen_catalunya.objetivo_cu"),
            getField("volumen_catalunya.porcentaje_conseguido"),
            getField("volumen_catalunya.porcentaje_red"),
            getField("volumen_catalunya.red_revisada"),
        ],
    },
    // KPI 2: Clientes (40%)
    {
        key: "clientes_catalunya",
        label: "2º KPI: CLIENTES (40%)",
        type: "group",
        children: [
            getField("clientes_catalunya.periodo_actual"),
            getField("clientes_catalunya.periodo_anterior"),
            getField("clientes_catalunya.objetivo_porcentaje"),
            getField("clientes_catalunya.objetivo_cu"),
            getField("clientes_catalunya.porcentaje_conseguido"),
            getField("clientes_catalunya.porcentaje_red"),
            getField("clientes_catalunya.red_revisada"),
        ],
    },
    // KPI 3: Cilindros Refrescos VR (20%)
    {
        key: "cilindros_refrescos_vr_catalunya",
        label: "3º KPI: REF. ESP (20%)",
        type: "group",
        children: [
            getField("cilindros_refrescos_vr_catalunya.periodo_actual"),
            getField("cilindros_refrescos_vr_catalunya.periodo_anterior"),
            getField("cilindros_refrescos_vr_catalunya.objetivo_porcentaje"),
            getField("cilindros_refrescos_vr_catalunya.objetivo_cu"),
            getField("cilindros_refrescos_vr_catalunya.porcentaje_conseguido"),
            getField("cilindros_refrescos_vr_catalunya.porcentaje_red"),
            getField("cilindros_refrescos_vr_catalunya.red_revisada"),
        ],
    },
    {
        key: "resultados",
        label: "Resultados",
        type: "group",
        children: [
            getField("resultados.redencion_total"),
            getField("resultados.redencion_revisada"),
            getField("resultados.volumen"),
            getField("resultados.comision"),
            getField("resultados.importe_total"),
        ],
    },
];
// Grouped table fields structure for CATALUNYA
export const TABLE_FIELDS_CATALUNYA_RPV = [
    // Basic fields (no group)
    getField("delegacion", { width: "220px" }),
    getField("distribuidor", { width: "300px" }),
    // KPI 1: Volumen RPV
    {
        key: "volumen_catalunya_rpv",
        label: "Volumen (25%)",
        type: "group",
        children: [
            getField("volumen_catalunya_rpv.periodo_actual"),
            getField("volumen_catalunya_rpv.periodo_anterior"),
            getField("volumen_catalunya_rpv.objetivo_porcentaje"),
            getField("volumen_catalunya_rpv.objetivo_cu"),
            getField("volumen_catalunya_rpv.porcentaje_conseguido"),
        ],
    },
    // KPI 2: Clientes RPV
    {
        key: "clientes_catalunya_rpv",
        label: "Compradores",
        type: "group",
        children: [
            getField("clientes_catalunya_rpv.periodo_actual"),
            getField("clientes_catalunya_rpv.periodo_anterior"),
            getField("clientes_catalunya_rpv.porcentaje_conseguido"),
        ],
    },
    // KPI 3: Ref.Prom.
    {
        key: "ref_prom_catalunya_rpv",
        label: "Ref.Prom.",
        type: "group",
        children: [
            getField("clientes_catalunya_rpv.periodo_actual"),
            getField("clientes_catalunya_rpv.periodo_anterior"),
            getField("clientes_catalunya_rpv.porcentaje_conseguido"),
        ],
    },
    // KPI 4: Volumen esp RPV
    {
        key: "volumen_esp_catalunya_rpv",
        label: "Volumen ESP",
        type: "group",
        children: [
            getField("volumen_esp_catalunya_rpv.vol_aact"),
            getField("volumen_esp_catalunya_rpv.vol_aant"),
            getField("volumen_esp_catalunya_rpv.porcentaje_conseguido"),
        ],
    },
    // KPI 5: Clientes esp RPV
    {
        key: "clientes_esp_catalunya_rpv",
        label: "Clientes ESP",
        type: "group",
        children: [
            getField("clientes_esp_catalunya_rpv.clientes_aact"),
            getField("clientes_esp_catalunya_rpv.clientes_aant"),
            getField("clientes_esp_catalunya_rpv.porcentaje_conseguido"),
        ],
    },
];
function pickCanariasTitle(variants, slotType, fallback) {
    const dbValue = variants === null || variants === void 0 ? void 0 : variants[`title_${slotType}`];
    return (dbValue !== null && dbValue !== void 0 ? dbValue : undefined) || fallback;
}
export function tableFieldsCanarias(kpiTypes, titleOverrides) {
    const isClientes = (t) => t === "clientes" || t === "clientes_pct";
    const faltantesLabel = (t) => isClientes(t) ? "Clientes faltantes" : "Volumen faltante";
    const actualLabel = (t) => isClientes(t) ? "Clientes_A" : "Vol_A";
    const anteriorLabel = (t) => isClientes(t) ? "Clientes_Ant" : "Vol_Ant";
    const slot1GroupLabel = (t) => isClientes(t) ? "Incremento Total Clientes" : "Incremento Total Ventas";
    const growGroupLabel = (t) => t === "clientes_pct"
        ? "Crecer en clientes compradores ref.esp. (%)"
        : t === "clientes"
            ? "Crecer en clientes compradores ref.esp. (núm. Clientes)"
            : t === "volumen_pct"
                ? "Crecer en volumen ref. esp. (%)"
                : "Crecer en volumen ref. esp.";
    return [
        getField("delegacion", { width: "120px" }),
        getField("sala", { width: "90px" }),
        getField("distribuidor", { width: "220px" }),
        {
            key: "incremento_total_ventas_cu",
            label: pickCanariasTitle(titleOverrides === null || titleOverrides === void 0 ? void 0 : titleOverrides.get("incremento_total_ventas_cu"), kpiTypes.slot1, slot1GroupLabel(kpiTypes.slot1)),
            type: "group",
            children: [
                { key: "incremento_total_ventas_cu.periodo_actual", label: actualLabel(kpiTypes.slot1), type: "float", align: "right" },
                { key: "incremento_total_ventas_cu.periodo_anterior", label: anteriorLabel(kpiTypes.slot1), type: "float", align: "right" },
                { key: "incremento_total_ventas_cu.objetivo_porcentaje", label: "Propuesta", type: "string", align: "right" },
                { key: "incremento_total_ventas_cu.objetivo_cu", label: "Objetivo", type: "float", align: "right" },
                { key: "incremento_total_ventas_cu.cajas_faltantes", label: faltantesLabel(kpiTypes.slot1), type: "float", align: "right" },
                { key: "incremento_total_ventas_cu.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
            ],
        },
        {
            key: "total_vidrio_retornable_mdo_local",
            label: pickCanariasTitle(titleOverrides === null || titleOverrides === void 0 ? void 0 : titleOverrides.get("total_vidrio_retornable_mdo_local"), kpiTypes.slot2, growGroupLabel(kpiTypes.slot2)),
            type: "group",
            children: [
                { key: "total_vidrio_retornable_mdo_local.periodo_actual", label: actualLabel(kpiTypes.slot2), type: "float", align: "right" },
                { key: "total_vidrio_retornable_mdo_local.periodo_anterior", label: anteriorLabel(kpiTypes.slot2), type: "float", align: "right" },
                { key: "total_vidrio_retornable_mdo_local.objetivo_porcentaje", label: "Propuesta", type: "string", align: "right" },
                { key: "total_vidrio_retornable_mdo_local.objetivo_cu", label: "Objetivo", type: "float", align: "right" },
                { key: "total_vidrio_retornable_mdo_local.cajas_faltantes", label: faltantesLabel(kpiTypes.slot2), type: "float", align: "right" },
                { key: "total_vidrio_retornable_mdo_local.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
            ],
        },
        {
            key: "crecer_volumen_fuze_te",
            label: pickCanariasTitle(titleOverrides === null || titleOverrides === void 0 ? void 0 : titleOverrides.get("crecer_volumen_fuze_te"), kpiTypes.slot3, growGroupLabel(kpiTypes.slot3)),
            type: "group",
            children: [
                { key: "crecer_volumen_fuze_te.periodo_actual", label: actualLabel(kpiTypes.slot3), type: "float", align: "right" },
                { key: "crecer_volumen_fuze_te.periodo_anterior", label: anteriorLabel(kpiTypes.slot3), type: "float", align: "right" },
                { key: "crecer_volumen_fuze_te.objetivo_porcentaje", label: "Propuesta", type: "string", align: "right" },
                { key: "crecer_volumen_fuze_te.objetivo_cu", label: "Objetivo", type: "float", align: "right" },
                { key: "crecer_volumen_fuze_te.cajas_faltantes", label: faltantesLabel(kpiTypes.slot3), type: "float", align: "right" },
                { key: "crecer_volumen_fuze_te.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
            ],
        },
        {
            key: "crecer_clientes_compradores",
            label: pickCanariasTitle(titleOverrides === null || titleOverrides === void 0 ? void 0 : titleOverrides.get("crecer_clientes_compradores"), kpiTypes.slot4, growGroupLabel(kpiTypes.slot4)),
            type: "group",
            children: [
                { key: "crecer_clientes_compradores.periodo_actual", label: actualLabel(kpiTypes.slot4), type: "integer", align: "right" },
                { key: "crecer_clientes_compradores.periodo_anterior", label: anteriorLabel(kpiTypes.slot4), type: "integer", align: "right" },
                { key: "crecer_clientes_compradores.objetivo", label: "Objetivo", type: "integer", align: "right" },
                { key: "crecer_clientes_compradores.clientes_faltantes", label: faltantesLabel(kpiTypes.slot4), type: "integer", align: "right" },
                { key: "crecer_clientes_compradores.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
            ],
        },
    ];
}
export const TABLE_FIELDS_MADRID = [
    // Basic fields (no group)
    getField("delegacion_zona_de_ventas", { width: "220px" }),
    {
        key: "data",
        label: "Datos periodo",
        type: "group",
        children: [
            getField("volumen_mad.periodo_actual", { label: "Volumen", type: "float" }),
            getField("volumen_acumulado_mad.periodo_actual", { label: "Volumen acum.", type: "float" }),
            getField("clientes_mad.periodo_actual", { label: "Compradores" }),
            getField("ref_promedio_mad.periodo_actual", { label: "Ref. Prom.", type: "float" }),
            getField("cajas_regalo_mad.periodo_actual", { label: "Cajas de regalo", type: "float" }),
            getField("gda_mad.gda_ho_f1.periodo_actual"),
            getField("gda_mad.gda_ho_f2.periodo_actual"),
            getField("gda_mad.gda_ho_f3.periodo_actual"),
            getField("gda_mad.gda_al_f1.periodo_actual"),
            getField("gda_mad.gda_al_f2.periodo_actual"),
            getField("gda_mad.gda_al_f3.periodo_actual"),
        ],
    },
    {
        key: "volumen",
        label: "Volumen",
        type: "group",
        children: [
            getField("volumen_mad.min", { label: "MIN", type: "float" }),
            getField("volumen_mad.max", { label: "MAX", type: "float" }),
        ],
    },
    {
        key: "volumen_acum",
        label: "Volumen acum.",
        type: "group",
        children: [
            getField("volumen_acumulado_mad.min", { label: "MIN", type: "float" }),
            getField("volumen_acumulado_mad.max", { label: "MAX", type: "float" }),
            getField("volumen_acumulado_mad.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "compradores",
        label: "Compradores",
        type: "group",
        children: [
            getField("clientes_mad.min", { label: "MIN", type: "float" }),
            getField("clientes_mad.max", { label: "MAX", type: "float" }),
            getField("clientes_mad.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "ref_prom",
        label: "Ref. Prom.",
        type: "group",
        children: [
            getField("ref_promedio_mad.min", { label: "MIN", type: "float" }),
            getField("ref_promedio_mad.max", { label: "MAX", type: "float" }),
            getField("ref_promedio_mad.porcentaje_crecimiento", {
                label: "% Crec.",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "cajas_regalo",
        label: "Cajas de regalo",
        type: "group",
        children: [
            getField("cajas_regalo_mad.max", { label: "MIN", type: "float" }),
            getField("cajas_regalo_mad.min", { label: "MAX", type: "float" }),
            getField("cajas_regalo_mad.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
            }),
        ],
    },
    {
        key: "gda_ho_f1",
        label: "Fanta Vidrio (HL)",
        type: "group",
        children: [
            getField("gda_mad.gda_ho_f1.min", { label: "MIN", type: "float" }),
            getField("gda_mad.gda_ho_f1.max", { label: "MAX", type: "float" }),
            getField("gda_mad.gda_ho_f1.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "gda_ho_f2",
        label: "Sprite Vidrio (HL)",
        type: "group",
        children: [
            getField("gda_mad.gda_ho_f2.min", { label: "MIN", type: "float" }),
            getField("gda_mad.gda_ho_f2.max", { label: "MAX", type: "float" }),
            getField("gda_mad.gda_ho_f2.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "gda_ho_f3",
        label: "Fuze TEA/AQ (HL)",
        type: "group",
        children: [
            getField("gda_mad.gda_ho_f3.min", { label: "MIN", type: "float" }),
            getField("gda_mad.gda_ho_f3.max", { label: "MAX", type: "float" }),
            getField("gda_mad.gda_ho_f3.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "gda_al_f1",
        label: "Fuze TEA (AL)",
        type: "group",
        children: [
            getField("gda_mad.gda_al_f1.min", { label: "MIN", type: "float" }),
            getField("gda_mad.gda_al_f1.max", { label: "MAX", type: "float" }),
            getField("gda_mad.gda_al_f1.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "gda_al_f2",
        label: "Bodyarmor/Powerade (AL)",
        type: "group",
        children: [
            getField("gda_mad.gda_al_f2.min", { label: "MIN", type: "float" }),
            getField("gda_mad.gda_al_f2.max", { label: "MAX", type: "float" }),
            getField("gda_mad.gda_al_f2.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "gda_al_f3",
        label: "Lata 500 (Coke/Fanta/Sprite)",
        type: "group",
        children: [
            getField("gda_mad.gda_al_f3.min", { label: "MIN", type: "float" }),
            getField("gda_mad.gda_al_f3.max", { label: "MAX", type: "float" }),
            getField("gda_mad.gda_al_f3.porcentaje_conseguido", {
                label: "%",
                type: "percent",
                align: "right",
                formatOptions: { percentInputScale: "whole" },
            }),
        ],
    },
    {
        key: "result",
        label: "Resultado",
        type: "group",
        children: [
            getField("volumen_mad.result", { label: "Volumen", type: "percent" }),
            getField("volumen_acumulado_mad.result", { label: "Volumen acum.", type: "percent" }),
            getField("clientes_mad.result", { label: "Compradores", type: "percent" }),
            getField("ref_promedio_mad.result", { label: "Ref. Prom.", type: "percent" }),
            getField("cajas_regalo_mad.result", { label: "Cajas de regalo", type: "percent" }),
            getField("gda_mad.gda_ho_f1.result", { type: "percent" }),
            getField("gda_mad.gda_ho_f2.result", { type: "percent" }),
            getField("gda_mad.gda_ho_f3.result", { type: "percent" }),
            getField("gda_mad.gda_al_f1.result", { type: "percent" }),
            getField("gda_mad.gda_al_f2.result", { type: "percent" }),
            getField("gda_mad.gda_al_f3.result", { type: "percent" }),
        ],
    },
];
// Grouped table fields structure for BALEARES (region E200)
export const TABLE_FIELDS_BALEARES = [
    getField("delegacion", { width: "120px" }),
    getField("delegacion_zona_de_ventas", { width: "220px" }),
    getField("zona_de_ventas", { width: "120px" }),
    getField("sala", { width: "100px" }),
    // KPI 1: Volumen Total
    {
        key: "volumen_total_distribucion_baleares",
        label: "1º KPI: Volumen Total",
        type: "group",
        children: [
            { key: "volumen_total_distribucion_baleares.vol_aact", label: "Vol A/Act", type: "float", align: "right" },
            { key: "volumen_total_distribucion_baleares.vol_aant", label: "Vol A/Ant", type: "float", align: "right" },
            { key: "volumen_total_distribucion_baleares.propuesta_1_kpi", label: "% Objetivo", type: "percent", align: "right" },
            { key: "volumen_total_distribucion_baleares.objetivo_cu", label: "Objetivo", type: "float", align: "right" },
            { key: "volumen_total_distribucion_baleares.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
        ],
    },
    // KPI 2: Clientes Total
    {
        key: "clientes_total_distribucion_baleares",
        label: "2º KPI: Clientes Total",
        type: "group",
        children: [
            { key: "clientes_total_distribucion_baleares.clientes_aact", label: "Clientes A/Act", type: "integer", align: "right" },
            { key: "clientes_total_distribucion_baleares.clientes_aant", label: "Clientes A/Ant", type: "integer", align: "right" },
            { key: "clientes_total_distribucion_baleares.propuesta_2_kpi", label: "Incr. Objetivo", type: "integer", align: "right" },
            { key: "clientes_total_distribucion_baleares.objetivo", label: "Objetivo", type: "integer", align: "right" },
            { key: "clientes_total_distribucion_baleares.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
        ],
    },
    // KPI 3: Volumen Esp (Mixtas only — hidden when tipo_de_ruta === "Especializada")
    {
        key: "volumen_total_vitrio_retornable_baleares",
        label: "3º KPI: Vol Esp",
        type: "group",
        children: [
            { key: "volumen_total_vitrio_retornable_baleares.vol_esp_aact", label: "Vol Esp A/Act", type: "float", align: "right" },
            { key: "volumen_total_vitrio_retornable_baleares.vol_esp_aant", label: "Vol Esp A/Ant", type: "float", align: "right" },
            { key: "volumen_total_vitrio_retornable_baleares.propuesta_3_kpi", label: "% Objetivo", type: "percent", align: "right" },
            { key: "volumen_total_vitrio_retornable_baleares.objetivo_cu", label: "Objetivo", type: "float", align: "right" },
            { key: "volumen_total_vitrio_retornable_baleares.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
        ],
    },
    // KPI 4: Clientes Esp (Mixtas only — hidden when tipo_de_ruta === "Especializada")
    {
        key: "clientes_total_vitrio_retornable_baleares",
        label: "4º KPI: Clientes Esp",
        type: "group",
        children: [
            { key: "clientes_total_vitrio_retornable_baleares.clientes_esp_aact", label: "Cli Esp A/Act", type: "integer", align: "right" },
            { key: "clientes_total_vitrio_retornable_baleares.clientes_esp_aant", label: "Cli Esp A/Ant", type: "integer", align: "right" },
            { key: "clientes_total_vitrio_retornable_baleares.propuesta_4_kpi", label: "Incr. Objetivo", type: "integer", align: "right" },
            { key: "clientes_total_vitrio_retornable_baleares.objetivo", label: "Objetivo", type: "integer", align: "right" },
            { key: "clientes_total_vitrio_retornable_baleares.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
        ],
    },
    // KPI 5: Variable (Especializadas only — hidden when tipo_de_ruta === "Mixta")
    {
        key: "variable_kpi_esp_baleares",
        label: "5º KPI: Variable (Vol/Cli Esp)",
        type: "group",
        children: [
            { key: "variable_kpi_esp_baleares.vol_esp_1_aact", label: "Vol/Cli Esp A/Act", type: "float", align: "right" },
            { key: "variable_kpi_esp_baleares.clientes_esp_1_aact", label: "Cli Esp 1 A/Act", type: "float", align: "right" },
            { key: "variable_kpi_esp_baleares.propuesta_5_kpi", label: "Objetivo", type: "float", align: "right" },
            { key: "variable_kpi_esp_baleares.porcentaje_conseguido", label: "% Conseguido", type: "percent", align: "right" },
        ],
    },
];
/**
 * Maps a results-report column-group key to the DB objective `type` value
 * returned by /webapi/objetivos/assigned, only where the two differ.
 * Resolution rule: OBJECTIVE_GROUP_TYPE_MAP[groupKey] ?? groupKey
 */
export const OBJECTIVE_GROUP_TYPE_MAP = {
    canon_variable: "canon_2025",
    clientes_catalunya_rpv: "compradores_catalunya_rpv",
    // Catalunya RPV stores the volumen objective with the legacy DB type
    // "volumen_catalunya"; the results group key is "volumen_catalunya_rpv".
    volumen_catalunya_rpv: "volumen_catalunya",
};
// Helper para detectar si los datos son de Norte
export function isNorthData(data) {
    return currentUser().area_code === "N";
}
// Helper para detectar si los datos son de Catalunya
export function isCatalunyaData(data) {
    return data.length > 0 && 'volumen_catalunya' in data[0];
}
// Helper para detectar si los datos son de Catalunya RPV
export function isCatalunyaRPVData(data) {
    return data.length > 0 && 'volumen_catalunya_rpv' in data[0];
}
export function isCanariasData(data) {
    return data.length > 0 && currentUser().region_code === "S300" && 'incremento_total_ventas_cu' in data[0];
}
export function isLevanteData(data) {
    return data.length > 0 && currentUser().region_code === "E300";
}
export function isBalearesData(data) {
    return currentUser().region_code === "E200";
}
// Resuelve la etiqueta de un grupo de objetivo usando el nombre vivo de BD
// cuando existe en el title map; en caso contrario conserva la etiqueta hardcoded.
const resolveGroupLabel = (groupKey, hardcodedLabel, titleMap) => {
    var _a, _b;
    const lookupKey = (_a = OBJECTIVE_GROUP_TYPE_MAP[groupKey]) !== null && _a !== void 0 ? _a : groupKey;
    return (_b = titleMap === null || titleMap === void 0 ? void 0 : titleMap.get(lookupKey)) !== null && _b !== void 0 ? _b : hardcodedLabel;
};
// Aplica los nombres vivos de BD a las etiquetas de los grupos de objetivo.
// Solo clona en superficie el wrapper de grupo ({ ...field, label }); los
// children se comparten y nunca se mutan los TABLE_FIELDS_* originales.
const applyTitles = (fields, titleMap) => fields.map((field) => field.type === "group"
    ? Object.assign(Object.assign({}, field), { label: resolveGroupLabel(field.key, field.label, titleMap) }) : field);
// Función para obtener los campos de tabla correctos según la región
export function getTableFields(data, titleMap, canariasTitleOverrides) {
    var _a;
    if (isNorthData(data)) {
        const user = currentUser();
        const hasNorthAreaScopeWithoutRegion = user.area_code === "N" && !user.region_code;
        const hasNorthFullScope = user.region_code === "N300" || hasNorthAreaScopeWithoutRegion;
        const northFields = hasNorthAreaScopeWithoutRegion
            ? [getField("region_de_ventas", { width: "140px" }), ...TABLE_FIELDS_NORTH]
            : TABLE_FIELDS_NORTH;
        if (!hasNorthFullScope) {
            return applyTitles(northFields.filter((field) => field.key !== "rutas_cfl_clientes_fuze_mantener"), titleMap);
        }
        return applyTitles(northFields, titleMap);
    }
    else if (isCatalunyaData(data)) {
        return applyTitles(TABLE_FIELDS_CATALUNYA, titleMap);
    }
    else if (isCatalunyaRPVData(data)) {
        return applyTitles(TABLE_FIELDS_CATALUNYA_RPV, titleMap);
    }
    else if (isCanariasData(data)) {
        const normalizeSlot = (v) => v === "clientes_pct"
            ? "clientes_pct"
            : v === "clientes"
                ? "clientes"
                : v === "volumen_pct"
                    ? "volumen_pct"
                    : "volumen";
        const first = (_a = data[0]) !== null && _a !== void 0 ? _a : {};
        const kpiTypes = {
            slot1: normalizeSlot(first.kpi_slot_1_type),
            slot2: normalizeSlot(first.kpi_slot_2_type),
            slot3: normalizeSlot(first.kpi_slot_3_type),
            slot4: normalizeSlot(first.kpi_slot_4_type),
        };
        // Canarias group labels are computed from the runtime KPI slot type, not
        // from the single DB `name` field, so applyTitles is intentionally not
        // called. The DB title variants per resolved slot type are passed via the
        // overrides map, with hardcoded fallback when a variant is null/absent.
        return tableFieldsCanarias(kpiTypes, canariasTitleOverrides);
    }
    else if (isLevanteData(data)) {
        return applyTitles(tableFieldsLevante(data), titleMap);
    }
    else if (isBalearesData(data)) {
        return applyTitles(TABLE_FIELDS_BALEARES, titleMap);
    }
    else if (currentUser().region_code === "C100") {
        return applyTitles(TABLE_FIELDS_MADRID, titleMap);
    }
    return applyTitles(TABLE_FIELDS_CENTER, titleMap);
}
// Por compatibilidad, exportar TABLE_FIELDS_CENTER como TABLE_FIELDS
export const TABLE_FIELDS = TABLE_FIELDS_CENTER;
const isNorthAreaUser = currentUser().area_code === "N";
const isLevanteRegionUser = currentUser().region_code === "E300";
const isCanariasRegionUser = currentUser().region_code === "S300";
const isCatalunyaRegionUser = currentUser().region_code === "E100";
const isCatalunyaRpvUser = currentUser().area_code === "E200RPV";
const isBalearesRegionUser = currentUser().region_code === "E200"; // Baleares + Menorca
const isSouthAreaUser = currentUser().area_code === "S"; // South default + Canarias
const isEastAreaUser = currentUser().area_code === "E";
const northFilterFields = ["delegacion", "sala", "distribuidor"];
const levanteFilterFields = ["delegacion", "distribuidor"];
const catalunyaFilterFields = ["delegacion", "distribuidor"];
const balearesFilterFields = ["delegacion_zona_de_ventas", "delegacion", "zona_de_ventas", "distribuidor"];
const southFilterFields = ["delegacion_zona_de_ventas", "delegacion", "zona_de_ventas", "distribuidor"];
const eastDefaultFilterFields = ["delegacion", "distribuidor"];
const defaultFilterFields = ["delegacion_zona_de_ventas", "delegacion", "zona_de_ventas", "distribuidor"];
// Filter fields (Center/Madrid default; authoritative selection lives in getFilterFields)
export const FILTER_FIELDS = defaultFilterFields;
export function getFilterFields() {
    const hasNorthAreaScopeWithoutRegion = isNorthAreaUser && !currentUser().region_code;
    if (hasNorthAreaScopeWithoutRegion) {
        return ["region_de_ventas", ...northFilterFields];
    }
    // Most-specific first
    if (isNorthAreaUser)
        return northFilterFields;
    if (isLevanteRegionUser)
        return levanteFilterFields;
    if (isCatalunyaRpvUser)
        return catalunyaFilterFields;
    if (isCatalunyaRegionUser)
        return catalunyaFilterFields;
    if (isBalearesRegionUser)
        return balearesFilterFields;
    if (isCanariasRegionUser)
        return southFilterFields;
    if (isSouthAreaUser)
        return southFilterFields;
    if (isEastAreaUser)
        return eastDefaultFilterFields;
    return defaultFilterFields; // Center C200 / Madrid C100
}
// Sortable fields
export const SORTABLE_FIELDS = isNorthAreaUser
    ? [
        "delegacion",
        "sala",
        "distribuidor",
        "clientes_productivos.periodo_actual",
        "clientes_productivos.periodo_anterior",
        "clientes_productivos.objetivo_porcentaje",
        "clientes_productivos.porcentaje_cumplimiento",
        "cf_vidrio_retornable.periodo_actual",
        "cf_vidrio_retornable.periodo_anterior",
        "cf_vidrio_retornable.objetivo_porcentaje",
        "canon_variable.periodo_actual",
        "canon_variable.periodo_anterior",
        "canon_variable.porcentaje_crecimiento",
        "canon_variable.red_total",
        "canon_variable.importe_total",
    ]
    : isLevanteRegionUser
        ? [
            "delegacion",
            "distribuidor",
            "total_objetivos_conseguidos",
        ]
        : [
            "delegacion_zona_de_ventas",
            "distribuidor",
            "volumen.periodo_actual",
            "volumen.periodo_anterior",
            "volumen.objetivo_porcentaje",
            "volumen.porcentaje_conseguido",
            "volumen_acumulado.periodo_actual",
            "volumen_acumulado.porcentaje_conseguido",
            "clientes.periodo_actual",
            "clientes.periodo_anterior",
            "total_volumen",
            "total_volumen_acumulado",
        ];
// Default sort configuration
export const DEFAULT_SORTS = isNorthAreaUser
    ? [
        { field: "delegacion", direction: "asc" },
        { field: "sala", direction: "asc" },
        { field: "distribuidor", direction: "asc" },
    ]
    : isLevanteRegionUser
        ? [
            { field: "delegacion", direction: "asc" },
            { field: "distribuidor", direction: "asc" },
        ]
        : isCanariasRegionUser
            ? [
                { field: "delegacion", direction: "asc" },
                { field: "is_total_row", direction: "asc" },
                { field: "delegacion_zona_de_ventas", direction: "asc" },
            ]
            : [{ field: "delegacion_zona_de_ventas", direction: "asc" }];
// Preset sort configurations
export const PRESET_SORTS = isNorthAreaUser
    ? [
        {
            label: "Por Delegación + Sala",
            sorts: [
                { field: "delegacion", direction: "asc" },
                { field: "sala", direction: "asc" },
                { field: "distribuidor", direction: "asc" },
            ],
        },
        {
            label: "Por Distribuidor A-Z",
            sorts: [{ field: "distribuidor", direction: "asc" }],
        },
        {
            label: "Por Clientes (Mayor a Menor)",
            sorts: [{ field: "clientes_productivos.periodo_actual", direction: "desc" }],
        },
        {
            label: "Por Canon Variable",
            sorts: [{ field: "canon_variable.importe_total", direction: "desc" }],
        },
    ]
    : isLevanteRegionUser
        ? [
            {
                label: "Por Delegación + Distribuidor",
                sorts: [
                    { field: "delegacion", direction: "asc" },
                    { field: "distribuidor", direction: "asc" },
                ],
            },
            {
                label: "Por Distribuidor A-Z",
                sorts: [{ field: "distribuidor", direction: "asc" }],
            },
            {
                label: "Por Nº Objvos Conseg. REV",
                sorts: [{ field: "total_objetivos_conseguidos", direction: "desc" }],
            },
        ]
        : [
            {
                label: "Por Distribuidor A-Z",
                sorts: [{ field: "distribuidor", direction: "asc" }],
            },
            {
                label: "Por Volumen (Mayor a Menor)",
                sorts: [{ field: "volumen.periodo_actual", direction: "desc" }],
            },
            {
                label: "Por % Conseguido (Mayor a Menor)",
                sorts: [{ field: "volumen.porcentaje_conseguido", direction: "desc" }],
            },
            {
                label: "Por Distribuidor + Volumen Desc",
                sorts: [
                    { field: "distribuidor", direction: "asc" },
                    { field: "volumen.periodo_actual", direction: "desc" },
                ],
            },
            {
                label: "Por Delegación + % Conseguido",
                sorts: [
                    { field: "delegacion_zona_de_ventas", direction: "asc" },
                    { field: "volumen.porcentaje_conseguido", direction: "desc" },
                ],
            },
        ];
